module.exports = __webpack_public_path__ + "img/guide-student6.e95bd4b1.png";